<template>
    <div class="container">
      <div v-for="(question, index) in this.questions" :key="index" class="question" v-show="question.id === actualPage.id">
        <!--
        <p>{{ question.id }}</p>
        <p>{{ questionSkip }}</p>
        <p>-------</p>
        <p>{{ answers }}</p>
        <p>-----</p>
        -->
        <component
          :is="question.type"
          :data="question"
          @next-question="nextQuestion"
          @prev-question="prevQuestion"
          class="choices"
        ></component>

        <LangSelector @switchLang="setLang" :langs="source.langs" />
      </div>

      <!-- <p style="margin-top: 4rem">&nbsp;</p> -->
      <!-- <p>total questions: {{questions.length }}</p> -->
      <!-- <p>survey id: {{survey}}</p> -->
      <!-- <p>question id: {{question.id}}</p> -->
      <!-- <p>idlang : {{lang}}</p> -->
      <!-- <p>skips length: {{ skips.length }}</p> -->
      <!-- <p style="margin-top: 3rem;">{{ answers }}</p> -->

    </div>
</template>

<script>
import { surveys as surveysDb } from '@/database';
import LangSelector from '@/components/LangSelector';
import NoChoice from '@/components/NoChoice';
import SingleChoice from '@/components/SingleChoice';
import MultipleChoice from '@/components/MultipleChoice';
import TopOfMind from '@/components/TopOfMind';
import InputTextline from '@/components/InputTextline';
import MultipleTableRadio from '@/components/MultipleTableRadio';
import MultipleTableCheckbox from '@/components/MultipleTableCheckbox';
import EndSave from '@/components/EndSave';
import SliderChoice from '@/components/SliderChoice';

import '@/assets/css/global.scss';

export default {
   name: 'survey',

   props: {
     id: {
       type: Number
     },
   },

   components: {
     LangSelector,
     NoChoice,
     SingleChoice,
     MultipleChoice,
     TopOfMind,
     InputTextline,
     MultipleTableRadio,
     MultipleTableCheckbox,
     EndSave,
     SliderChoice,
   },

  data() {
    return {
      source: {},
      actualPage: null,
      lastPage: false,
      nextBtnDisabled: true,
      hasCustom: false,
      answers: [],
      skips: [],
      lang: 2,
      dtstart: 0,
      questionSkip: null,
    }
  },

  computed: {

    survey() {
      return this.source.id
    },

    questions() {
      return this.source.questions;
    },

    selectedChoices() {
      return this.answers.map((answer) => {
        if ( answer.choice ){ // single-choice
          return answer.choice;
        }
        if ( answer.choices ){ // multiple-choice
          return answer.choices.map((value) => {
            if ( value.custom == null ){
              return value.id;
            } else {
              return [value.id, value.custom];
            }
          })
        }
      }).flat();
    }
  },

  methods: {
    nextQuestion(response = null) {
      if (response !== null) {
        this.answers.push(response)
        if ( this.answers.length == 1 ){
          this.dtstart = Date.now();
        }
      }
      console.log('list the answers')
      console.dir(this.answers);
      console.log('the actual page id %s', this.actualPage.id)

      // let skips = []
      console.log('log the skips')
      console.dir(this.skips);
      // console.log(this.skips);

      let next = null;

      // check if there's a goto configured
      if ( this.actualPage.choices ) {
        this.actualPage.choices.forEach(choice => {
          if ( choice.goto && this.selectedChoices.includes(choice.id)){
            console.log('choice goto %s', choice.goto)
            next = choice.goto
            this.actualPage = this.questions.find(q => q.id === next)
          }
        })
      }
      console.log('next (aka goto) is %s', next)

      // if no goto, get the next byOrder
      if ( next === null ) {
        const index = this.questions.findIndex(q => {
          return q.order === this.actualPage.order
        });
        next = this.questions[index+1]
        this.actualPage = next;
      }

      // check if there's a skip
      console.log('list of choices selected');
      console.log(this.selectedChoices);

      let questionSkip = this.skips.find(el => el.question == this.actualPage.id);
      if(questionSkip !== undefined){
        this.questionSkip = questionSkip;
        let condition, groups;
        let skipSucccess = new Array;
        let totalSkips = 0;
        let groupValid = new Array;
        let useSome = false;
        let useEvery = false;
        let useEveryValid = false;

        // const idChoicesSelected = this.answers.map(answer => answer.choice);
        let test = {};
        this.answers.map((answer) => {
          if ( answer.choice ){ // single-choice
            return test[answer.choice] = true;
            // return answer.choice;
          }
          if ( answer.choices ){ // multiple-choice
            return answer.choices.map((value) => {
              if ( value.custom == null ){
                return test[value.id] = true;
                // return value.id;
              } else {
                return test[value.id] = value.custom;
                // return [value.id, value.custom];
              }
            })
          }
        });
        console.log(test);


        questionSkip.entries.forEach(entry => {
            groupValid = new Array;
            condition = entry.condition;
            if( condition === 'AND' ){
              console.log('missing code for AND verification');
              useEvery = true;
            }
            if( condition === 'OR' || condition === null ){
              console.log('missing code for OR verification');
              useSome = true;
            }
            console.log('the entry condition is %s', condition);
            groups = entry.group;
            // console.log('dump groups');
            totalSkips = 0
            groups.forEach(group => {
              totalSkips++;
              // console.log(group.idchoice);
              // console.log(group.value);

              if( group.value !== true && group.value !== false ){// value is probably a string (ex: "1,2,3")
                console.log('split the possible values');
                console.log(group.value.split(','));
                if( group.value.split(',').includes(test[group.idchoice]) ){
                  groupValid.push('valid');
                } else {
                  groupValid.push('invalid');
                }
              }

              if( group.value === true ){
                if( this.selectedChoices.includes(group.idchoice) ){
                  console.log('group.value = true, this condition is valid so push one to skip');
                  skipSucccess.push(group.idchoice);
                  groupValid.push('valid');
                }
              }

              if( group.value === false ){
                if( !this.selectedChoices.includes(group.idchoice) ){
                  console.log('group.value = false, this condition is valid so push one to skip');
                  skipSucccess.push(group.idchoice);
                  groupValid.push('valid');
                }
              }

            })

            if ( condition === 'AND'){
              if ( groupValid.length && groupValid.length === groups.length ){
                console.log('there is a valid group for an AND condition so we should skip')
                useEveryValid = true
              } else {
                console.log('!!!! another group but without all valid entries')
              }
            }
        })
        console.log('--------------   errors   -------------------');
        console.log(skipSucccess);
        console.log('totalSkips is %s', totalSkips);
        console.log('---------------- groups ---------------------');
        console.log(groups);
        console.log('---- groups.length -----------------')
        console.log(groups.length);
        console.log('----- groupValid ------');
        console.log(groupValid);
        console.log('groupValid length', groupValid.length)
        console.log('useSome is %s', useSome);
        console.log('useEvery is %s', useEvery);
        console.log('useEveryValid is %s', useEveryValid);

        if ( useSome ){
          if ( groupValid.length && groupValid.some(v => v === 'valid') ){
            console.log('should be skipped');
            return this.nextQuestion();
          }
        }

        if ( useEvery && useEveryValid ){
          console.log('should be skipped');
          return this.nextQuestion();
          // if ( groupValid.length && groupValid.every(v => v === 'valid') ){
          //   console.log('should be skipped');
          //   // return this.nextQuestion();
          // }
        }

        console.log('should not skip');

        // if(skipSucccess.length !== 0 && skipSucccess.length === totalSkips )
        //   return this.nextQuestion();
      }

      // this.skips.forEach(skip => {
      //   if( skip.question === this.actualPage.id ) {
      //     // console.log('the skip variable is ===== ');
      //     // console.log(skip);
      //     // this.questionSkip = skip;

      //     /* nuno@ion.lu - old code working before new approach with grouped conditional entries*/
      //     /*
      //     let skipQuestion = true;
      //     let incrementalSkip = false;
      //     let totalChoices = 0;
      //     let tmpSkipQuestion = [];
      //     // let skipQuestion = false;// tmp hack

      //     if ( skip.choices.length > 0 ){
      //       skip.choices.forEach((item) => {
      //         console.log('log the item');
      //         console.log(item);
      //         totalChoices = item.length;
      //         if( Array.isArray(item) ){// not a simple skip
      //           console.log('the item is an array');
      //           item.forEach(condition => {// cycle through the array
      //             console.log(condition.idchoice);
      //             console.log(condition.values);
      //             // run here the logic for each of the conditions
      //             const isSelectedChoice = this.selectedChoices.find((choice) => {
      //               // choice => {
      //               const selChoice = choice[0] !== undefined ? choice[0] : choice;
      //               console.log('choice');
      //               console.log(choice);
      //               console.log(choice.length);
      //               console.log('selChoice is %s', selChoice);
      //               // console.log('choice[0] is %s', choice[0]);
      //               // if( Array.isArray(choice) ){
      //               //   return choice[0] === condition.idchoice;
      //               // }
      //               return selChoice === condition.idchoice;
      //             });
      //             console.log('the isSelectedChoice is %s', isSelectedChoice);
      //             if( isSelectedChoice !== undefined ){
      //               console.log('item found');
      //               if( condition.values === undefined ){
      //                 console.log('in here');
      //                 console.log(this.selectedChoices.includes(isSelectedChoice));
      //                 // skipQuestion = false;
      //                 tmpSkipQuestion.push(1);
      //               } else if( condition.values.length > 0 && condition.values.split(',').includes((isSelectedChoice[1]).toString()) ){
      //                 console.log('isSelectedChoice[0] %s', isSelectedChoice[0]);
      //                 console.log('isSelectedChoice[1] %s', (isSelectedChoice[1]).toString());
      //                 // console.log(condition.values.split(','));
      //                 // skipQuestion = false;
      //                 console.log('is incrementalSkip');
      //                 incrementalSkip = true;
      //                 console.log('pushing into tmpSkipQuestion');
      //                 tmpSkipQuestion.push(1);
      //               }
      //             }
      //           });

      //           console.log('tmpSkipQuestion');
      //           console.log(tmpSkipQuestion);

      //           if( !incrementalSkip && tmpSkipQuestion.length === 0 )
      //             skipQuestion = false;

      //         } else {// simple skip
      //           console.log('the item is a simple skip');
      //           if( !this.selectedChoices.includes(item.idchoice) ){
      //             skipQuestion = false;
      //           }
      //         }
      //       });

      //     }

      //     // verify incremental conditional skips
      //     console.log('skip choices length is %s', skip.choices.length);
      //     console.log('tmpSkipQuestion length is %s', tmpSkipQuestion.length);
      //     if( incrementalSkip && tmpSkipQuestion.length > 0 && tmpSkipQuestion.length !== totalChoices )
      //       skipQuestion = false;

      //     console.log('skipQuestion value');
      //     console.log(skipQuestion);

      //     if(skipQuestion)
      //       return this.nextQuestion();
      //     */
      //   }

      // });

      this.nextBtnDisabled = this.actualPage.mandatory;// disable next button if the question is mandatory
      this.lastPage = this.actualPage.type == 'end-save' ? true : false;
   },

   prevQuestion() {
    console.log('previous question')
    console.log(this.actualPage.id)
    const { question } = this.answers.pop();
    const prev = this.questions.find(q => q.id === question)
    this.actualPage = prev;
   },

    setLang(id) {
      console.log(id);
      this.lang = id;
    }
  },

  created() {
    console.log('created successfully')
    console.log(this.id);
    surveysDb.getItem(this.id).then((obj) => {
      this.source = obj;
      this.actualPage = this.source.questions[0];

      this.source.questions.forEach((question) => {

        if( question.skips ){
          this.skips.push({
            "question": question.id,
            "entries": question.skips
          });
        }

        // if ( question.choices ){
        //   question.choices.forEach(choice => {
        //     if ( choice.skip && choice.skip.length > 0 ){
        //       choice.skip.forEach(idquestion => {
        //         console.log('the idquestion is %s', idquestion);
        //         console.dir(idquestion);
        //         if (typeof idquestion === 'object') {
        //           this.skips.push({
        //             "question": Object.keys(idquestion)[0],
        //             "choice": choice.id,
        //             "custom": Object.values(idquestion),
        //           })
        //         } else {
        //           this.skips.push({
        //             "question": idquestion,
        //             "choice": choice.id,
        //             "custom": null,
        //           })
        //         }
        //       })
        //     }
        //   })
        // }

      })
      console.log(this.skips)
    })
  },

  beforeRouteLeave (to, from, next){
    if ( this.lastPage ) {
      next();
    } else { // not the lastPage
      if( confirm('Are you sure you want to go away ? Unsaved data will be lost... forever!!!')) {
        next();
      } else {
        next(false)
      }
    }
  }
}
</script>

<style lang="scss">
  .lang-wrapper {
    position: absolute;
    top: 180px;
    left: 40px;
    width: 40px;
    // min-height: 100px;

    display: flex;
    align-items: flex-start;
    justify-content: center;

    border: 1px solid #999;
    border-radius: 3px;
    background-color: #e3e3e3;

    nav {
      padding: .5rem 0;

      ul {
        list-style: none outside none;

        li {
          height: 30px;

          a {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: .2rem .5rem;
            color: var(--primary);
            font-size: 1.4rem;
            font-weight: bold;
            background-color: white;
            border: 1px solid #333;
            border-radius: 2px;
            cursor: pointer;

            &:hover {
              color: white;
              background-color: var(--primary)
            }
          }
        }
      }
    }
  }
  @media (max-width: 900px) {
    .lang-wrapper {
      left: 30px;
    }
  }
</style>
